import { InfoMenu } from "../../../components/InfoMenu/InfoMenu";
import { News } from "../../../components/News/News";
import { ThemeModeSwitcher } from "../../../components/ThemeModeSwitcher";
import { UserDropdownMenu } from "../../../components/UserDropdownMenu/UserDropdownMenu";

const Navbar = () => {
  return (
    <div className="app-navbar flex-shrink-0">
      <div className="app-navbar-item tools ms-1 ms-lg-3">
        <InfoMenu />
        <News />
        <ThemeModeSwitcher />
      </div>
      <div className="app-navbar-item ms-1 ms-lg-0">
        <UserDropdownMenu />
      </div>
    </div>
  );
};

export { Navbar };
